import * as URI from 'urijs';
import { FC, useCallback, useEffect, useState } from 'react';

import { sanitizer } from '../../utils/xss-utils';

export const ContentEditableDisplay: FC<{ value: string; testId?: string }> = ({
  value,
  testId = `content-editable-display`,
}) => {
  // TODO?, Use what linkfiy used. Old lib in vuetify kinda sucked, but we had working code for it. Lib in linkify looks good
  // https://www.npmjs.com/package/linkify-it
  // https://github.com/tasti/react-linkify/blob/master/src/decorators/defaultMatchDecorator.js
  // https://github.com/tasti/react-linkify/blob/master/src/components/Linkify.jsx
  // The way they make actual react children is neat.
  // Probably better than this dangerously set inner html stuff
  // but... we don't want to parse the html we already have in the database. Nope. In theory it's simple HTML, but still nope.
  const [currentValue, setCurrentValue] = useState<string>('');

  const processValue = useCallback((value: string) => {
    const sanitized = sanitizer.process(value);

    const result = URI.withinString(sanitized, (url: string) => {
      // This URI library gets it wrong if we have a html tag after the hyperlink.
      // Like http://foo.com</div> or http://blah<br>
      // Normally, we'd just return `<a href="${url}" target="_blank" contenteditable="false">${ url }</a>`;
      // and move on. But, we cannot.
      // < is not valid in a uri, so, we'll split on < and only wrap the first bit of that array
      const splitOnLeftAngle = url.split('<');
      const firstElement = splitOnLeftAngle[0];
      // this library also is less good if there's an &nbsp; at the end of the url
      // which will happen if you put a space before hitting enter
      // which is normally ok, except if you do http://foo.com/, hit space, hit enter
      // then we end up with http://foo.com/&nbsp; in the plain text
      // & is ok for urls, so the library dutifully gives us the "wrong" url of http://foo.com/&nbsp
      // this is even worse if we've got some html tags too
      // as we end up trying to process  http://foo.com&nbsp;</div> as the url
      const firstElementSplitOnNbsp = firstElement.split('&nbsp');
      // wrap the actual url part in a link
      // target blank because we want them out in a new window.
      // contenteditable false because we want the whole url to go away if they hit delete/backspace
      // rel noopener noreferrer to stop a security exploit https://github.com/dbudwin/react-secure-link#the-exploit-
      let result = `<a href="${firstElementSplitOnNbsp[0]}" target="_blank" contenteditable="false" rel="noopener noreferrer">${firstElementSplitOnNbsp[0]}</a>`;
      if (firstElementSplitOnNbsp.length > 0) {
        // there was an nbsp in there.
        // Tack on everything joined up with nbsp so we get the space come out directly after the link
        result += '&nbsp' + firstElementSplitOnNbsp.slice(1).join('&nbsp');
      }
      if (splitOnLeftAngle.length > 1) {
        // there was a left angle bracket in there
        // Tack on everything joined up with an angle bracket
        result += '<' + splitOnLeftAngle.slice(1).join('<');
      }
      return result;
    });
    return result;
  }, []);

  useEffect(() => {
    setCurrentValue(processValue(value));
  }, [processValue, value]);
  return (
    <div
      css={{
        overflowWrap: 'break-word',
        wordWrap: 'break-word',
        wordBreak: 'break-word',
        hyphens: 'auto',
      }}
      dangerouslySetInnerHTML={{ __html: currentValue }}
      data-testid={testId}
    />
  );
};
